import FileSelectorModule from './file-selector.module'

export default FileSelectorModule
